import React from 'react'
import PropTypes from 'prop-types'

const LandingHeroStatic = ({ heroSection, history, showButtons }) => {
  return (
    <div className='hero-img' style={{ minHeight: '450px', backgroundImage: `url("${heroSection.imgURL}")` }} alt='hero image' data-cy='hero-img'>
      <div className='row align-items-center px-0 px-md-5' style={{ minHeight: '450px' }}>
        <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 p-0 p-lg-5'>
          {heroSection.noHeroBox
            ? null
            : heroSection.stretchContent
              ? (
                <div className='p-5'>
                  <h1 className='hero-text mb-4 text-center'>{heroSection.title}</h1>
                  <div className='hero-description mb-3'><div dangerouslySetInnerHTML={{ __html: heroSection.description }} /></div>
                  <div className='text-center'>
                    {showButtons &&
                      <div>
                        <button className='btn btn-primary mb-3 mx-2' data-cy='hero-prescreen' onClick={() => history.push({ pathname: '/prescreening' })}>{heroSection.btn1_text}</button>
                        <button className='btn btn-outline-primary mb-3 mx-2' data-cy='hero-required-docs' onClick={() => history.push({ pathname: '/required-documents' })}>{heroSection.btn2_text}</button>
                      </div>
                    }
                  </div>
                </div>
              ) : (
                <div className='hero-content col-12 col-lg-6 col-xl-4 align-items-center pb-0'>
                  <div className='px-3 px-lg-0'>
                    <h1 className='hero-text'>{heroSection.title}</h1>
                    <div className='hero-description mb-3'><div dangerouslySetInnerHTML={{ __html: heroSection.description }} /></div>
                    <div className='text-left pb-4'>
                      {showButtons &&
                        <div>
                          <button className='btn btn-primary mb-3 me-3' data-cy='hero-prescreen' onClick={() => history.push({ pathname: '/prescreening' })}>{heroSection.btn1_text}</button>
                          <button className='btn btn-outline-primary mb-3' data-cy='hero-required-docs' onClick={() => history.push({ pathname: '/required-documents' })}>{heroSection.btn2_text}</button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
    </div>
  )
}

LandingHeroStatic.propTypes = {
  heroSection: PropTypes.object,
  history: PropTypes.object,
  showButtons: PropTypes.bool
}

export default LandingHeroStatic
